import React, { useState, useEffect, useMemo } from 'react';
import Swal from 'sweetalert2';
import api from '../services/api';
import '../styles/CargaRapidaNomina.css';
import { obtenerFechaLocal } from '../utils/dateUtils';

const CargaRapidaNomina = ({ empleadosProyecto, proyectoId, onComplete }) => {
    
    const [filas, setFilas] = useState({});
    const [busqueda, setBusqueda] = useState(''); 
    const [fecha, setFecha] = useState(obtenerFechaLocal);
    const [enviando, setEnviando] = useState(false);
    const [cuentasBancarias, setCuentasBancarias] = useState([]);
    const [listaInterna, setListaInterna] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [mostrarAyuda, setMostrarAyuda] = useState(false);

    useEffect(() => {
        api.get('/bancos/cuentas')
            .then(r => setCuentasBancarias(r.data.cuentas || []))
            .catch(() => {});
    }, []);

    // 🚨 CORREGIDO: Usar la ruta correcta del controlador financiero
    useEffect(() => {
        console.log("📥 empleadosProyecto recibido:", empleadosProyecto);
        
        if (empleadosProyecto && empleadosProyecto.length > 0) {
            console.log("✅ Usando empleados del prop:", empleadosProyecto.length);
            setListaInterna(empleadosProyecto.filter(e => e.activo !== false));
            setLoading(false);
        } else {
            console.log("⚠️ empleadosProyecto vacío, cargando desde API...");
            cargarEmpleados();
        }
    }, [empleadosProyecto]);

    // 🚨 CORREGIDO: Ruta API correcta según tu controlador financiero
    const cargarEmpleados = async () => {
        try {
            setLoading(true);
            setError(null);
            
            // Usar la ruta correcta del controlador financiero
            // De proyectoFinancieroController.js: export const obtenerEmpleados = async (req, res) => {
          const res = await api.get(`/proyectos/${proyectoId}/empleados`);
            
            if (res.data && Array.isArray(res.data)) {
                const empleadosActivos = res.data.filter(e => e.activo !== false);
                setListaInterna(empleadosActivos);
                console.log("✅ Empleados cargados desde API:", empleadosActivos.length);
                
                if (empleadosActivos.length === 0) {
                    setError("No hay empleados activos en este proyecto");
                }
            } else {
                setError("Formato de respuesta inválido");
            }
        } catch (err) {
            console.error("❌ Error cargando empleados:", err);
            
            // Mensajes de error más específicos
            if (err.response?.status === 404) {
                setError("Ruta no encontrada. Verifica el endpoint del backend.");
            } else if (err.response?.status === 401) {
                setError("No autorizado. Inicia sesión nuevamente.");
            } else if (err.message?.includes('Network Error')) {
                setError("Error de conexión. Verifica tu internet.");
            } else {
                setError(`Error al cargar empleados: ${err.message || 'Error desconocido'}`);
            }
            
            // Fallback: intentar con otra ruta común
            try {
                const resAlternativa = await api.get(`/proyectos/${proyectoId}/empleados`);
                if (resAlternativa.data && Array.isArray(resAlternativa.data)) {
                    const empleadosActivos = resAlternativa.data.filter(e => e.activo !== false);
                    setListaInterna(empleadosActivos);
                    setError(null);
                    console.log("✅ Empleados cargados desde ruta alternativa");
                }
            } catch (err2) {
                console.error("❌ Error en ruta alternativa:", err2);
            }
        } finally {
            setLoading(false);
        }
    };

    const empleadosFiltrados = useMemo(() => {
        return listaInterna.filter(emp => {
            const nombre = emp.nombre || '';
            const cargo = emp.cargo || '';
            return nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
                   cargo.toLowerCase().includes(busqueda.toLowerCase());
        });
    }, [busqueda, listaInterna]);

    // 🚨 CORREGIDO: Función handleChange mejorada
   const handleChange = (id, campo, valor) => {
    console.log(`✍️ Editando ID ${id} | Campo: ${campo} | Valor: ${valor}`);
    
    setFilas(prev => {
        const nuevaFila = { ...(prev[id] || {}) };
        
        // Actualizar el valor del campo que cambió
        if (campo === 'cantidad') {
            nuevaFila[campo] = valor === '' ? '' : parseFloat(valor) || 0;
        } else {
            nuevaFila[campo] = valor;
        }
        
        // Buscar el empleado para conocer su tipo_pago y tarifa
        const emp = listaInterna.find(e => e.id === id);
        
        // 🚀 LÓGICA DE CÁLCULO AUTOMÁTICO EN TIEMPO REAL
        if (emp && campo === 'cantidad' && emp.tarifa_dia > 0) {
            const cantidad = parseFloat(valor) || 0;
            const tarifa = parseFloat(emp.tarifa_dia);
            const esquema = (emp.tipo_pago || '').toLowerCase();
            let montoCalculado = 0;

            // Si el usuario pone cantidad, multiplicamos según el tipo de pago
            if (cantidad > 0) {
                // Para todos los esquemas (diario, semanal, mensual, contrato), 
                // multiplicamos la cantidad por la tarifa base definida en el origen.
                montoCalculado = cantidad * tarifa;
            }
            
            // Solo actualizamos el monto si se calculó algo mayor a 0
            if (montoCalculado > 0) {
                nuevaFila.monto = montoCalculado.toFixed(2);
            }
        }
        
        return { ...prev, [id]: nuevaFila };
    });
};
            
       
    // 🚨 NUEVO: Calcular todos automáticamente
   const calcularTodos = () => {
    const nuevasFilas = {};
    
    listaInterna.forEach(emp => {
        const cantidadActual = filas[emp.id]?.cantidad || 0;
        const tarifa = parseFloat(emp.tarifa_dia || 0);
        
        if (cantidadActual > 0 && tarifa > 0) {
            const monto = cantidadActual * tarifa;
            nuevasFilas[emp.id] = {
                ...(filas[emp.id] || {}),
                cantidad: cantidadActual,
                monto: monto.toFixed(2)
            };
        }
    });
    setFilas(nuevasFilas);
};

    // 🚨 CORREGIDO: Función guardar con mejor manejo
    const guardar = async () => {
        // Validar datos
        const empleadosConDatos = listaInterna.filter(emp => {
            const fila = filas[emp.id];
            return fila && (fila.cantidad > 0 || parseFloat(fila.monto || 0) > 0);
        });
        
        if (empleadosConDatos.length === 0) {
            alert("⚠️ Ingresa cantidades o montos para al menos un empleado");
            return;
        }

          if (fecha > obtenerFechaLocal()) {
            alert(`⚠️ No se puede registrar nómina para fechas futuras.\n\nFecha seleccionada: ${fecha}\nFecha actual: ${obtenerFechaLocal()}\n\nPor favor, selecciona una fecha válida.`);
            setEnviando(false);
            return;
        }
        
        // Preparar payload según el controlador
        const empleadosPayload = empleadosConDatos.map(emp => {
            const fila = filas[emp.id];
            return {
                EmpleadoProyectoId: emp.id,
                nombre: emp.nombre,
                cantidad: fila.cantidad || 0,
                monto: parseFloat(fila.monto) || 0,
                horas: fila.cantidad || 0 // Para compatibilidad
            };
        });
        
        const payload = {
            ProyectoId: proyectoId,
            fecha: fecha,
            tipo_registro: 'rapido',
            empleados: empleadosPayload
        };
        
        console.log("📤 Enviando payload:", payload);

        // Modal método de pago
        const opcionesCuentas = cuentasBancarias
            .map(c => `<option value="${c.id}">${c.nombre} — ${c.banco}</option>`)
            .join('');
        const sinCuentas = cuentasBancarias.length === 0;

        const { value: formValues } = await Swal.fire({
            title: '¿Método de pago?',
            html: `
              <div style="text-align:left; margin-bottom:10px;">
                <label style="font-weight:600; display:block; margin-bottom:6px;">Método</label>
                <select id="swal-metodo" class="swal2-input" style="margin:0; width:100%;">
                  <option value="efectivo">Efectivo</option>
                  <option value="transferencia">Transferencia bancaria</option>
                </select>
              </div>
              <div id="swal-cuenta-wrap" style="text-align:left; display:none;">
                <label style="font-weight:600; display:block; margin-bottom:6px;">Cuenta bancaria</label>
                <select id="swal-cuenta" class="swal2-input" style="margin:0; width:100%;">
                  ${opcionesCuentas}
                </select>
              </div>
              <div id="swal-sin-cuentas" style="display:none; background:#fef3c7; border:1px solid #f59e0b; border-radius:8px; padding:12px; text-align:left; font-size:13px; color:#92400e;">
                ⚠️ No tienes cuentas bancarias registradas.<br/>
                Ve a <strong>Banco / Tesorería</strong> para agregar una antes de usar transferencia.
              </div>
            `,
            didOpen: () => {
                document.getElementById('swal-metodo').addEventListener('change', e => {
                    const esTransferencia = e.target.value === 'transferencia';
                    document.getElementById('swal-cuenta-wrap').style.display =
                        esTransferencia && !sinCuentas ? 'block' : 'none';
                    document.getElementById('swal-sin-cuentas').style.display =
                        esTransferencia && sinCuentas ? 'block' : 'none';
                });
            },
            preConfirm: () => {
                const metodo = document.getElementById('swal-metodo').value;
                if (metodo === 'transferencia' && sinCuentas) {
                    Swal.showValidationMessage('Debes registrar una cuenta bancaria primero en Banco / Tesorería');
                    return false;
                }
                return {
                    metodo_pago: metodo,
                    cuenta_bancaria_id: document.getElementById('swal-cuenta')?.value || null,
                };
            },
            showCancelButton: true,
            confirmButtonColor: '#10b981',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Confirmar pago',
            cancelButtonText: 'Cancelar',
        });

        if (!formValues) return; // canceló

        try {
            setEnviando(true);
            const response = await api.post('/nomina/masiva', {
                ...payload,
                metodo_pago: formValues.metodo_pago,
                cuenta_bancaria_id: formValues.cuenta_bancaria_id,
            });
            console.log("✅ Respuesta:", response.data);

            Swal.fire('✅ Nómina guardada', `${empleadosConDatos.length} empleados registrados`, 'success');
            setFilas({});
            if (onComplete) onComplete();

        } catch (err) {
            console.error("❌ Error guardando:", err);
            const mensaje = err.response?.data?.error || err.message || 'Error desconocido';
            Swal.fire('❌ Error', mensaje, 'error');
        } finally {
            setEnviando(false);
        }
    };

    // Calcular total
    const totalGeneral = useMemo(() => {
        return Object.values(filas).reduce((total, fila) => {
            return total + (parseFloat(fila.monto) || 0);
        }, 0);
    }, [filas]);

    // 🎨 ESTILOS EN LÍNEA MEJORADOS
    const styles = {
        container: {
            background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
            borderRadius: '16px',
            border: '1px solid #bae6fd',
            boxShadow: '0 4px 20px rgba(14, 165, 233, 0.15)',
            overflow: 'hidden',
            marginBottom: '24px'
        },
        header: {
            background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
            color: 'white',
            padding: '24px',
            borderBottom: '3px solid #60a5fa'
        },
        title: {
            fontSize: '22px',
            fontWeight: '700',
            margin: '0 0 8px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
        },
        subtitle: {
            fontSize: '14px',
            opacity: '0.9',
            margin: '0'
        },
        controls: {
            display: 'flex',
            gap: '15px',
            alignItems: 'center',
            marginTop: '20px',
            flexWrap: 'wrap'
        },
        inputGroup: {
            flex: '1',
            minWidth: '200px'
        },
        label: {
            fontSize: '12px',
            fontWeight: '600',
            marginBottom: '6px',
            display: 'block',
            color: '#dbeafe'
        },
        input: {
            width: '100%',
            padding: '10px 14px',
            borderRadius: '8px',
            border: '1px solid #93c5fd',
            fontSize: '14px',
            backgroundColor: 'rgba(255, 255, 255, 0.9)'
        },
        totalBadge: {
            background: 'rgba(255, 255, 255, 0.2)',
            padding: '10px 20px',
            borderRadius: '10px',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.3)'
        },
        totalLabel: {
            fontSize: '12px',
            fontWeight: '600',
            color: '#dbeafe',
            marginBottom: '4px'
        },
        totalAmount: {
            fontSize: '24px',
            fontWeight: '700',
            color: 'white'
        },
        actions: {
            padding: '16px 24px',
            background: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            display: 'flex',
            gap: '12px',
            alignItems: 'center'
        },
        button: {
            padding: '10px 20px',
            borderRadius: '8px',
            border: 'none',
            fontWeight: '600',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.2s'
        },
        btnCalculate: {
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            color: 'white'
        },
        btnClear: {
            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
            color: 'white'
        },
        btnHelp: {
            background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
            color: 'white'
        },
        tableContainer: {
            padding: '20px',
            background: 'white'
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse'
        },
        th: {
            background: '#f1f5f9',
            padding: '14px 16px',
            textAlign: 'left',
            fontWeight: '600',
            fontSize: '13px',
            color: '#475569',
            borderBottom: '2px solid #e2e8f0'
        },
        td: {
            padding: '16px',
            borderBottom: '1px solid #f1f5f9',
            verticalAlign: 'middle'
        },
        badge: {
            padding: '6px 12px',
            borderRadius: '20px',
            fontSize: '12px',
            fontWeight: '600',
            display: 'inline-block'
        },
        badgeDay: {
            background: '#dbeafe',
            color: '#1e40af'
        },
        badgeHour: {
            background: '#dcfce7',
            color: '#166534'
        },
        badgeContract: {
            background: '#f3e8ff',
            color: '#7c3aed'
        },
        inputCell: {
            width: '100px',
            padding: '10px 12px',
            borderRadius: '6px',
            border: '2px solid #e2e8f0',
            fontSize: '14px',
            textAlign: 'center'
        },
        inputMonto: {
            width: '140px',
            padding: '10px 12px',
            borderRadius: '6px',
            border: '2px solid #e2e8f0',
            fontSize: '14px',
            textAlign: 'right',
            fontWeight: '600'
        },
        inputMontoFilled: {
            borderColor: '#10b981',
            backgroundColor: '#f0fdf4'
        },
        footer: {
            padding: '20px 24px',
            background: '#f8fafc',
            borderTop: '1px solid #e2e8f0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        summary: {
            display: 'flex',
            gap: '20px',
            alignItems: 'center'
        },
        summaryItem: {
            fontSize: '14px',
            color: '#64748b'
        },
        btnSave: {
            background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
            color: 'white',
            padding: '12px 30px',
            borderRadius: '10px',
            border: 'none',
            fontWeight: '600',
            fontSize: '16px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
        },
        loading: {
            padding: '40px',
            textAlign: 'center',
            color: '#64748b'
        },
        spinner: {
            border: '4px solid #f3f4f6',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
        },
        errorCard: {
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '10px',
            padding: '20px',
            margin: '20px',
            textAlign: 'center'
        },
        emptyState: {
            padding: '60px 20px',
            textAlign: 'center',
            color: '#64748b'
        },
        helpPanel: {
            background: '#f0f9ff',
            border: '1px solid #bae6fd',
            borderRadius: '10px',
            padding: '20px',
            margin: '20px'
        }

        
    };

    // Animación para spinner
    const spinAnimation = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;

    if (loading) {
        return (
            <div style={styles.container}>
                <style>{spinAnimation}</style>
                <div style={styles.loading}>
                    <div style={styles.spinner}></div>
                    <h3>Cargando empleados...</h3>
                    <p>Buscando empleados activos del proyecto</p>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            <style>{spinAnimation}</style>
            
          <div style={styles.header}>
    <h2 style={styles.title}>🚀 Carga Rápida de Nómina</h2>
    
    {/* Contenedor de controles ajustado */}
    <div className="nomina-header-controls">
        
        <div className="input-group">
            <label style={styles.label}>Buscar empleado</label>
            <input 
                id="employee-search"
                type="text" 
                placeholder="Nombre o cargo..."
                className="nomina-input-search"
                value={busqueda}
                onChange={e => setBusqueda(e.target.value)}
            />
        </div>

        <div className="input-group">
            <label style={styles.label}>Fecha de pago</label>
            <input 
                id="payment-date"
                type="date" 
                className="nomina-input-date"
                value={fecha}
                onChange={e => setFecha(e.target.value)}
                max={obtenerFechaLocal()}
                required
            />
        </div>

        {/* Badge de total alineado a la derecha */}
        <div className="total-badge">
            <div style={styles.totalLabel}>TOTAL A PAGAR</div>
            <div style={styles.totalAmount}>
                RD$ {totalGeneral.toLocaleString('es-DO', { minimumFractionDigits: 2 })}
            </div>
        </div>
        
    </div>
</div>
            
            {/* Mensaje de error */}
            {error && (
                <div style={styles.errorCard}>
                    <h3 style={{color: '#dc2626', marginTop: 0}}>⚠️ Error</h3>
                    <p>{error}</p>
                    <button 
                        onClick={cargarEmpleados}
                        style={{
                            ...styles.button,
                            background: '#3b82f6',
                            color: 'white',
                            marginTop: '10px'
                        }}
                    >
                        🔄 Reintentar
                    </button>
                </div>
            )}
            
            {/* Panel de ayuda */}
            {mostrarAyuda && (
                <div style={styles.helpPanel}>
                    <h4 style={{marginTop: 0, color: '#1e40af'}}>📋 ¿Cómo funciona?</h4>
                    <p><strong>1.</strong> Ingresa la cantidad de <strong>días</strong> o <strong>horas</strong> trabajadas</p>
                    <p><strong>2.</strong> El sistema calculará automáticamente el monto basado en la tarifa del empleado</p>
                    <p><strong>3.</strong> Puedes ajustar manualmente el monto si es necesario</p>
                    <p><strong>4.</strong> Haz clic en "Calcular Automáticamente" para llenar todos los montos</p>
                    <button 
                        onClick={() => setMostrarAyuda(false)}
                        style={{
                            ...styles.button,
                            background: '#64748b',
                            color: 'white',
                            marginTop: '10px'
                        }}
                    >
                        ✕ Cerrar ayuda
                    </button>
                </div>
            )}
            
            {/* Acciones */}
            <div style={styles.actions}>
                <button 
                    onClick={calcularTodos}
                    style={{...styles.button, ...styles.btnCalculate}}
                    title="Calcular montos basados en tarifas"
                >
                    🧮 Calcular Automáticamente
                </button>
                
                <button 
                    onClick={() => setFilas({})}
                    style={{...styles.button, ...styles.btnClear}}
                    title="Limpiar todos los campos"
                >
                    🧹 Limpiar Campos
                </button>
                
                <button 
                    onClick={() => setMostrarAyuda(!mostrarAyuda)}
                    style={{...styles.button, ...styles.btnHelp}}
                >
                    {mostrarAyuda ? '❓ Ocultar ayuda' : '❓ Mostrar ayuda'}
                </button>
                
                <div style={{marginLeft: 'auto', fontSize: '13px', color: '#64748b'}}>
                    {empleadosFiltrados.length} de {listaInterna.length} empleados
                </div>
            </div>
            
            {/* Tabla de empleados */}
            <div style={styles.tableContainer}>
                {listaInterna.length === 0 ? (
                    <div style={styles.emptyState}>
                        <div style={{fontSize: '48px', marginBottom: '20px'}}>👤</div>
                        <h3>No hay empleados activos</h3>
                        <p>No se encontraron empleados activos en este proyecto.</p>
                        <button 
                            onClick={cargarEmpleados}
                            style={{
                                ...styles.button,
                                background: '#3b82f6',
                                color: 'white',
                                marginTop: '20px'
                            }}
                        >
                            🔄 Recargar empleados
                        </button>
                    </div>
                ) : (
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>Empleado / Cargo</th>
                                <th style={styles.th}>Tipo Pago</th>
                                <th style={{...styles.th, textAlign: 'center'}}>
                                    Cantidad
                                    <div style={{fontSize: '11px', fontWeight: 'normal'}}>
                                        (Días/Horas)
                                    </div>
                                </th>
                                <th style={{...styles.th, textAlign: 'center'}}>Tarifa</th>
                                <th style={{...styles.th, textAlign: 'right'}}>Monto Total (RD$)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {empleadosFiltrados.map(emp => {
                                const fila = filas[emp.id] || {};
                                const cantidad = fila.cantidad || '';
                                const monto = fila.monto || '';
                                const tieneMonto = parseFloat(monto) > 0;
                                
                                return (
                                    <tr key={emp.id} style={{
                                        ...styles.td,
                                        background: tieneMonto ? '#f0f9ff' : 'transparent'
                                    }}>
                                        <td style={styles.td}>
                                            <div>
                                                <strong>{emp.nombre}</strong>
                                                <div style={{fontSize: '13px', color: '#64748b'}}>
                                                    {emp.cargo || 'Sin cargo especificado'}
                                                </div>
                                            </div>
                                        </td>
                                        
                                        <td style={styles.td}>
                                            <span style={{
                                                ...styles.badge,
                                                ...(emp.tipo_pago === 'por_dia' ? styles.badgeDay : 
                                                    emp.tipo_pago === 'por_hora' ? styles.badgeHour : 
                                                    styles.badgeContract)
                                            }}>
                                                {emp.tipo_pago === 'por_dia' ? 'Por Día' : 
                                                 emp.tipo_pago === 'por_hora' ? 'Por Hora' : 
                                                 'Contrato'}
                                            </span>
                                        </td>
                                        
                                        <td style={{...styles.td, textAlign: 'center'}}>
                                            <input 
                                                type="number"
                                                min="0"
                                                step="0.5"
                                                placeholder="0"
                                                style={styles.inputCell}
                                                value={cantidad}
                                                onChange={e => handleChange(emp.id, 'cantidad', e.target.value)}
                                            />
                                        </td>
                                        
                                        <td style={{...styles.td, textAlign: 'center'}}>
                                            <div>
                                                <strong style={{color: '#1e40af'}}>
                                                    RD$ {parseFloat(emp.tarifa_dia || 0).toLocaleString()}
                                                </strong>
                                                <div style={{fontSize: '12px', color: '#64748b'}}>
                                                    {emp.tipo_pago === 'por_dia' ? '/día' : 
                                                     emp.tipo_pago === 'por_hora' ? '/hora' : 'fijo'}
                                                </div>
                                            </div>
                                        </td>
                                        
                                        <td style={{...styles.td, textAlign: 'right'}}>
                                            <input 
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                placeholder="0.00"
                                                style={{
                                                    ...styles.inputMonto,
                                                    ...(tieneMonto ? styles.inputMontoFilled : {})
                                                }}
                                                value={monto}
                                                onChange={e => handleChange(emp.id, 'monto', e.target.value)}
                                            />
                                            {tieneMonto && (
                                                <div style={{fontSize: '12px', color: '#64748b', marginTop: '4px'}}>
                                                    {parseFloat(monto).toLocaleString('es-DO', {
                                                        minimumFractionDigits: 2
                                                    })}
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
                
                {empleadosFiltrados.length === 0 && listaInterna.length > 0 && (
                    <div style={{textAlign: 'center', padding: '40px', color: '#64748b'}}>
                        🔍 No se encontraron empleados con "{busqueda}"
                    </div>
                )}
            </div>
            
            {/* Footer */}
            <div style={styles.footer}>
                <div style={styles.summary}>
                    <div style={styles.summaryItem}>
                        <strong>{Object.keys(filas).filter(id => parseFloat(filas[id]?.monto || 0) > 0).length}</strong> empleados con monto
                    </div>
                    <div style={styles.summaryItem}>
                        Total: <strong style={{color: '#059669', fontSize: '18px'}}>
                            RD$ {totalGeneral.toLocaleString('es-DO', {minimumFractionDigits: 2})}
                        </strong>
                    </div>
                </div>
                
                <button 
                    onClick={guardar}
                    disabled={enviando || totalGeneral === 0}
                    style={{
                        ...styles.btnSave,
                        opacity: (enviando || totalGeneral === 0) ? 0.6 : 1,
                        cursor: (enviando || totalGeneral === 0) ? 'not-allowed' : 'pointer'
                    }}
                    title={totalGeneral === 0 ? "Ingresa montos para guardar" : ""}
                >
                    {enviando ? (
                        <>
                            <span style={{
                                width: '16px',
                                height: '16px',
                                border: '2px solid white',
                                borderTop: '2px solid transparent',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                display: 'inline-block'
                            }}></span>
                            Guardando...
                        </>
                    ) : (
                        <>
                            💾 Guardar Nómina
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default CargaRapidaNomina;